// resources.js
import $ from 'jquery';

export default {
  init() {
    // Pagination buttons
    $('.resources-pagination-buttons').on('click', '.resources-load-more-button', function () {
      const targetPage = parseInt($(this).data('page'));
      ResourcesperformSearchAndPagination(targetPage);
    });

    function ResourcesperformSearchAndPagination(targetPage = 1, isFirstCall = false) {
      $('.resources-wrap').addClass('loading');

      const selectedFilter = $('input[name="resources_tax_filter[]"]:checked')
        .map(function () { return this.value; })
        .get();

      const selectedTaxonomy = $('input[name="resources_tax_filter[]"]:checked')
        .first()
        .data('taxonomy') || '';

      const searchTerm = $('input[name="resources_search_filter"]').val();

      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'load_resources',
          selected_taxonomy: selectedTaxonomy,
          selected_filter: selectedFilter,
          resources_search_filter: searchTerm,
          resourcesPaged: targetPage,
        },
        success: function (response) {
          const parsed = JSON.parse(response);

          $('.resources-wrap').html(parsed.html);
          $('.resources-pagination-buttons').html(parsed.pagination);

          $('.resources-wrap').removeClass('loading');

          if (!isFirstCall) {
            $('html, body').animate(
              { scrollTop: $('.resources-filter-section').offset().top },
              800
            );
          }
        },
        error: function (err) {
          console.log(err);
        },
      });
    }

    // Initial load
    ResourcesperformSearchAndPagination(1, true);

    function showResetButton() {
      $('.clear-filter-button').show();
    }

    // Search
    $('input[name="resources_search_filter"]').on('keypress', function (e) {
      if (e.which === 13) {
        ResourcesperformSearchAndPagination(1);
      }
    });

    // Optional search button
    $('#resourcesSearch').on('click', function () {
      ResourcesperformSearchAndPagination(1);
    });

    // Checkbox filter change
    $('.filter-dropdown input[type="checkbox"]').on('change', function () {
      ResourcesperformSearchAndPagination(1);
      showResetButton();
    });

    // Search input focus
    $('input[name="resources_search_filter"]').on('focus', function () {
      showResetButton();
      $(this).addClass('focused');
    });

    // Clear filters button
    $('.clear-filter-button').on('click', function () {
      $('input[name="resources_search_filter"]').val('').removeClass('focused');
      $('input[name="resources_tax_filter[]"]').prop('checked', false);
      $('.dropdown-toggle .dropdown-text').text('Select all that apply');

      $(this).hide();
      ResourcesperformSearchAndPagination(1);
    });

    // Search typing + icon swap
    $('input[name="resources_search_filter"]').on('keyup', function () {
      const value = $(this).val();
      if (value.length > 0) {
        $('.search-icon-container .icon-search').hide();
        $('.search-icon-container .icon-clear').show();
      } else {
        $('.search-icon-container .icon-search').show();
        $('.search-icon-container .icon-clear').hide();
        ResourcesperformSearchAndPagination(1);
      }
    });

    $('.search-icon-container .icon-clear').on('click', function () {
      $('input[name="resources_search_filter"]').val('').blur();
      $('.search-icon-container .icon-search').show();
      $('.search-icon-container .icon-clear').hide();
      ResourcesperformSearchAndPagination(1);

      if ($('input[name="resources_tax_filter[]"]:checked').length === 0) {
        $('.clear-filter-button').hide();
      }
    });

    // Dropdown open/close
    $(document).on('click', '.dropdown-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest('.filter-dropdown').toggleClass('open');
    });

    $(document).on('click', function () {
      $('.filter-dropdown').removeClass('open');
    });

    $('.dropdown-menu').on('click', function (e) {
      e.stopPropagation();
    });

    // Update dropdown text with selected options
    $('.filter-checkbox').on('change', function () {
      updateDropdownText();
    });

    function updateDropdownText() {
      const selected = $('.filter-checkbox:checked')
        .map(function () { return $(this).parent().text().trim(); })
        .get();

      const text = selected.length > 0 ? selected.join(', ') : 'Select all that apply';
      $('.dropdown-toggle .dropdown-text').html(text);
    }
  },
  finalize() {},
};
